import styled from "styled-components";

export const CourseWrapper = styled.section`
  margin: 10px 0px;
`;

export const CourseHolder = styled.div`
  width: 90%;
  margin: 35px auto;
`;

export const CourseBoxImage = styled.img`
  width: 100%;
  height: 200px;
  border-radius: 4px;
`;